// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "image-grid-module--base-text-alt--global--f0757";
export var baseTextGlobal = "image-grid-module--base-text--global--487b1";
export var blockSpacing100 = "image-grid-module--block-spacing-100--3c27c";
export var blockSpacing50 = "image-grid-module--block-spacing-50--acf99";
export var blockVPadding100 = "image-grid-module--block-v-padding-100--32b0b";
export var blockVPadding50 = "image-grid-module--block-v-padding-50--2849b";
export var body = "image-grid-module--body--fc0f9";
export var captionTextGlobal = "image-grid-module--caption-text--global--382f2";
export var cmsRenderedContentGlobal = "image-grid-module--cms-rendered-content--global--48401";
export var container = "image-grid-module--container--bd801";
export var defaultHSpacingGlobal = "image-grid-module--default-h-spacing--global--876e0";
export var descriptionContainer = "image-grid-module--descriptionContainer--d0c11";
export var fadeInAnimation = "image-grid-module--fadeInAnimation--edf92";
export var fadeInOnLoadGlobal = "image-grid-module--fade-in-on-load--global--a3f01";
export var fullHeightGlobal = "image-grid-module--full-height--global--564d5";
export var fullHeightOmittingNavGlobal = "image-grid-module--full-height-omitting-nav--global--209d0";
export var grid = "image-grid-module--grid--9abb4";
export var headingTextGlobal = "image-grid-module--heading-text--global--13a9b";
export var image = "image-grid-module--image--10986";
export var imageContainer = "image-grid-module--imageContainer--03e26";
export var imagesOnly = "image-grid-module--imagesOnly--f8273";
export var ingressTextGlobal = "image-grid-module--ingress-text--global--e68a6";
export var item2 = "image-grid-module--item2--8514c";
export var item3 = "image-grid-module--item3--95455";
export var item4 = "image-grid-module--item4--7206d";
export var items1 = "image-grid-module--items1--9f5b4";
export var items2 = "image-grid-module--items2--324ec";
export var items3 = "image-grid-module--items3--4ed39";
export var items4 = "image-grid-module--items4--35686";
export var linkColorChangeTransitionGlobal = "image-grid-module--link-color-change-transition--global--7bdd9";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "image-grid-module--page-heading-text--global--d8b30";
export var paragraphTextGlobal = "image-grid-module--paragraph-text--global--3d7c4";
export var subheadingTextGlobal = "image-grid-module--subheading-text--global--f832f";
export var title = "image-grid-module--title--1686c";